export default class FormateDropdown {
  constructor(navbar) {
    this.navbar = navbar;
    this.isOpen = false;

    this.formateDropdown = document.querySelector(".formate-dropdown");
    this.formateDropdownBackdrop = document.querySelector(
      ".formate-dropdown-backdrop"
    );
    this.headerButtons = document.querySelectorAll(
      ".wp-block-button.is-style-header"
    );

    this.headerButtons.forEach((headerButton) => {
      headerButton.addEventListener(
        "click",
        this._handleHeaderButtonClick.bind(this)
      );
    });

    this.formateDropdownBackdrop.addEventListener(
      "click",
      this._close.bind(this)
    );
  }

  _handleHeaderButtonClick() {
    if (this.isOpen) {
      this._close();
    } else {
      this._open();
    }
  }

  _open() {
    this.navbar.classList.add("page-navbar--fomate-dropdown-open");
    this.isOpen = true;
  }

  _close() {
    this.navbar.classList.remove("page-navbar--fomate-dropdown-open");
    this.isOpen = false;
  }
}
